export { default } from "wonderbly-components/lib/Testimonial";
